import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import dummyImg from "../../assets/images/dummyImg.png";
import FetchData from "../../providers/dataProvider";

const ViewCompany = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [viewItem, setViewItem] = useState(null);

  const {
    data: designationdata,
    loading: designationLoading,
    error: designationError,
  } = FetchData("designation");

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      const itemCopy = { ...item };
      if (itemCopy) {
        itemCopy?.compContacts?.map((obj) => {
          const designationObj = designationdata?.find(
            (el) => el?.id == obj?.designationId
          );
          if (designationObj)
            obj["designationName"] = designationObj?.designationName;
          else obj["designationName"] = "";

          return obj;
        });
        const positionObj = designationdata?.find(
          (el) => el?.id == itemCopy?.designationId
        );
        if (positionObj)
          itemCopy["positionName"] = positionObj?.designationName;
        else itemCopy["positionName"] = "";
      }
      setViewItem(itemCopy);
    } else {
      navigate("/company-master");
    }
  }, [location?.state, designationdata]);

  return (
    <div className="container-fluid view-company-sec">
      <section className="company-view-sec">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-2">
              <div className="card-header pl-3">
                <div class="d-flex justify-content-start align-items-center w-100 flex-wrap">
                  <Link to="/company-master">
                    <button className="btn p-0 mr-2" type="button">
                      <i class="fas fa-angle-left"></i>
                    </button>
                  </Link>
                  <h1>General</h1>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Company Name</h5>
                      <h6>{viewItem?.companyName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Country</h5>
                      <h6>{viewItem?.countryName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Website</h5>
                      <h6>{viewItem?.website}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Fax Number</h5>
                      <h6>{viewItem?.fax}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Phone Number</h5>
                      <h6>{viewItem?.phone}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Email Address</h5>
                      <h6>{viewItem?.email}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Authorized Person</h5>
                      <h6>{viewItem?.authorizedPerson}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Position</h5>
                      <h6>{viewItem?.positionName}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Address</h5>
                      <h6>{viewItem?.address}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Status</h5>
                      <h6>{viewItem?.status}</h6>
                    </div>
                  </div>
                </div>
                {/* <div className='row'>
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div>
                                            <h5>Additional Info</h5>
                                            <h6>{viewItem?.companyName}</h6>
                                        </div>
                                    </div>
                                </div> */}
                <div className="row company-document-upload-row mt-3">
                  <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div>
                      <label>Company Logo</label>
                      <div className="uploaded-file">
                        <img src={dummyImg} className="w-100"></img>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div>
                      <label>Letterpad Header</label>
                      <div className="uploaded-file">
                        <img src={dummyImg} className="w-100"></img>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div>
                      <label>Letterpad Footer</label>
                      <div className="uploaded-file">
                        <img src={dummyImg} className="w-100"></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card contacts-card">
              <div className="card-header pl-3">
                <h1>Contacts</h1>
              </div>
              <div className="card-body">
                <div className="row mt-2 contact-view-area">
                  {viewItem?.compContacts?.length > 0 ? (
                    viewItem?.compContacts?.map((obj) => (
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mb-2">
                        <div className="view-contact">
                          <i className="far fa-user-circle"></i>
                          <h5>{obj?.name}</h5>
                          <span>{obj?.email}</span>
                          <p>{obj?.designationName}</p>
                          <p>{obj?.phone}</p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 no-contact">
                      <p>No contacts avilable</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 mb-4">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="text-right mob-mt-13 mob-mb-15">
              <Link to="/company-master">
                <button className="btn back-btn" type="button">
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewCompany;
